import { useState, useRef } from "react";
import { Col, Row, Card, CardText, Form, CardBody } from "reactstrap";
// drop
import Dropzone from "react-dropzone";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// leitor
import readXlsxFile from "read-excel-file";
// modelo
import ModeloUpload from "../../../assets/statics/modelo_push.xlsx";
// validações e utils
import {
  allExcelColumns,
  findRowsWithError,
  excelColumnsPtBr,
  formateDate,
  validationDate,
  validationPartGroup,
} from "./ImportValidation";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
// componentes
import ModalExcelRows from "../Voo/ModalExcelRows";
//service
import { newNotification } from "../../../utils/services/notification";
import { getMobileAppsByEvent } from "../../../utils/services/mobileApps";
import { getParticipants } from "../../../utils/services/participants";
import { getGroups } from "../../../utils/services/group";

export default function ImportCreate(props) {
  const { idEvent, toggleModal, getData, eventName } = props;
  // documento
  const [selectedFiles, setselectedFiles] = useState([]);
  // linhas do doc
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const importActivated = useRef(false);
  // modal de erros no arquivo xlsx
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  // alerta
  const [success_dlg, setsuccess_dlg] = useState(false);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;
    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      Titulo: {
        prop: "title",
        type: String,
      },
      Foto: {
        prop: "photo",
        type: String,
      },
      TipoLink: {
        prop: "linkType",
        type: String,
      },
      Link: {
        prop: "link",
        type: String,
      },
      "Ação Multi-Idioma": {
        prop: "action",
        type: String,
      },
      Idioma: {
        prop: "language",
        type: String,
      },
      "Participante-Grupo": {
        prop: "partGroup",
        type: String,
      },
      "Enviar para": {
        prop: "sendTo",
        type: String,
      },
      Link: {
        prop: "link",
        type: String,
      },
      Mensagem: {
        prop: "message",
        type: String,
      },
      Data: {
        prop: "date",
        type: String,
      },
      Hora: {
        prop: "hour",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumns(row, i));

      const rowsWithError = findRowsWithError(validateRows);

      setTotalRows(validateRows.length);

      // validar colunas se esta no padrão
      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema);

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }

      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
        return;
      }

      const getDatesInvalids = await validationDate(validateRows);

      if (getDatesInvalids.length > 0 || rows.length === 0) {
        setErrors(getDatesInvalids);
        setModalErrors(true);
        return;
      }

      const getGroupsConst = await getGroups({
        eventId: idEvent,
        offset: 1,
        limit: 9999,
        search: "",
      });

      const allGroups =
        getGroupsConst?.message === "Groups_by_event"
          ? getGroupsConst.findOneGroupData.data
          : [];

      const getAllParticipantsConst = await getParticipants({
        idEvent: idEvent,
        offset: 1,
        limit: 9999,
        search: "",
        columnSearch: "login",
        status: "ATIVO",
      });

      const allParticipants =
        getAllParticipantsConst.message === "users"
          ? getAllParticipantsConst.data.data
          : [];

      const getPartGropupsInvalids = await validationPartGroup(
        validateRows,
        allGroups,
        allParticipants,
      );

      if (getPartGropupsInvalids.length > 0 || rows.length === 0) {
        setErrors(getPartGropupsInvalids);
        setModalErrors(true);
        return;
      }

      const getApps = await getMobileAppsByEvent({ eventId: idEvent });
      const mobileApps = getApps.findOneMobileAppData;

      for (const row of validateRows) {
        await importPushs(
          row,
          validateRows.length,
          mobileApps,
          allGroups,
          allParticipants,
        );
      }
    };

    readXlsx();

    async function loginsSelecteds(row, allParticipants) {
      const emails =
        row.sendTo.toUpperCase().trim() === "TODOS"
          ? allParticipants.map((e) => e.email)
          : row.sendTo.split(",");

      var loginsReturn = [];

      emails.map((e) => {
        const search = allParticipants.find(
          (part) => part.email.toLowerCase() === e.trim().toLowerCase(),
        );

        if (search)
          loginsReturn.push({
            login: search.id,
          });
      });

      return loginsReturn;
    }

    async function groupsSelecteds(row, allGroups) {
      const groups =
        row.sendTo.toUpperCase().trim() === "TODOS"
          ? allGroups.map((e) => e.name)
          : row.sendTo.split(",");

      var groupsReturn = [];

      groups.map((e) => {
        const search = allGroups.find(
          (part) => part.name.toLowerCase() === e.trim().toLowerCase(),
        );

        if (search)
          groupsReturn.push({
            grupo: search.id,
          });
      });

      return groupsReturn;
    }

    async function importPushs(
      row,
      totalRows,
      mobileApps,
      allGroups,
      allParticipants,
    ) {
      let mobileAppsArray = [];
      let firebaseProjectsId = [];

      mobileApps.map((e) => {
        mobileAppsArray.push(e?.bundle);
        firebaseProjectsId.push({
          firebaseProjectId: e?.idfirebaseproject,
          bundleId: e?.bundle,
        });
      });

      mobileAppsArray = mobileAppsArray.map((e) => `'${e}'`).join(",");
      firebaseProjectsId = JSON.stringify(firebaseProjectsId);

      const logins =
        row.partGroup.toUpperCase() === "PARTICIPANTE" ||
        row.partGroup.toUpperCase() === "PARTICIPANTES"
          ? await loginsSelecteds(row, allParticipants)
          : null;

      const groups =
        row.partGroup.toUpperCase() === "GRUPO" ||
        row.partGroup.toUpperCase() === "GRUPOS"
          ? await groupsSelecteds(row, allGroups)
          : null;

      var data = {
        title: row.title,
        text: row.message,
        date: await formateDate(row.date, row.hour),
        hour: row.hour,
        bundleId: mobileAppsArray.length > 0 ? mobileAppsArray : null,
        firebaseProjectId:
          firebaseProjectsId.length > 0 ? firebaseProjectsId : null,
        allLogins:
          row.partGroup &&
          (row.partGroup.toUpperCase() === "PARTICIPANTE" ||
            row.partGroup.toUpperCase() === "PARTICIPANTES") &&
          row.sendTo.toUpperCase().trim() === "TODOS",
        event: idEvent,
        schedule: true,
        image: row.photo,
        expireDate: null,
        multiIdiom: row.action ? true : false,
        sendToIdiom:
          row.action && row.action.toUpperCase() === "INDICAR IDIOMA"
            ? row.language
              ? row.language.split(",").map((s) => `'${s.trim()}'`).join(", ")
              : null
            : null,
        notSendToIdiom:
          row.action && row.action.toUpperCase() === "RETIRAR IDIOMA"
            ? row.language
              ? row.language.split(",").map((s) => `'${s.trim()}'`).join(", ")
              : null
            : null,
        linkLabel: row.linkType ? row.linkType : null,
        codeQrCode: "teste",
        link: row.link ? row.link : [],
        textHtml: "",
        btnOneText: "",
        btnOneColor: "",
        btnTwoText: "",
        btnTwoColor: "",
        eventTitle: eventName,
        eventDescription: "",
      };

      if (logins) {
        data = {
          ...data,
          logins: logins,
        };
      }

      if (groups) {
        data = {
          ...data,
          grupos: groups,
        };
      }

      const res = await newNotification(data);

      if (res.message === "NOTIFICATION_CREATED") {
        setTotalSended(count++);
      }

      if (count === totalRows || (count === 2 && totalRows === 1)) {
        setsuccess_dlg(true);
      }
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBr}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            getData();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_push.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}

            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Enviar Push
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
